export const applyTranslationOverrides = (i18nInstance, overrides) => {
    for (const [lng, resources] of Object.entries(overrides)) {
        if (resources && Object.keys(resources).length > 0) {
            i18nInstance.addResourceBundle(lng, 'translation', resources, true, true);
        }
    }
};
